"use client";
import { ReactNode } from "react";
import { ErrorBoundary } from './Error'
import { GlobalProvider } from '@/context';

const Layout = async ({children}: {children: ReactNode;}) => {
  return (
    <ErrorBoundary>
      <GlobalProvider>
        {children}
      </GlobalProvider>
    </ErrorBoundary>
  )
}

export default Layout;